const AttestationMainScreen = () => {
    return (
        <>
            <div className="page-attestation">
                <div className="outer-wrapper rw1 py-6">
                    <div className="inner-wrapper max-w-[70rem] mx-auto items-center ">
                        <div className="lg:flex grid lg:justify-center flex-1 gap-[6rem] flex-wrap ">
                            <div className="lg:flex grid px-10 lg:justify-center flex flex-col justify-center my-[2rem]">
                                <h2 className="sm:text-[40px] text-[30px] font-extrabold text-[#6c6767] leading-none">Get Your</h2>
                                <h1 className="sm:text-[44px] text-[30px] font-extrabold leading-none">Documents</h1>
                                <h2 className="sm:text-[40px] text-[30px] font-extrabold">Attested Via <span className="text-[#F21E26] font-extrabold">TCS</span></h2>
                                <p className="text-[1.05rem] mt-[-5px]">We have launched a completely secure and robust online<br/> degree attestation system, which requires an applicant to <br/>apply from their homes easilu.  </p>
                                <h2 className="text-1xl font-semibold leading-9">Track Your Document</h2>
                                <div className="">
                                    <div className="flex">
                                        <input type="number" placeholder="Enter your Tracking Number" className="p-3 md:w-[15rem] focus:outline-none opacity-75 rounded-l-sm border"/>
                                        <button type="button" className="bg-[#D40511] text-white p-3 w-full md:w-[7rem] rounded-r-sm transition-all duration-500 gradientbg">Track</button>
                                    </div>
                                </div>
                            </div>
                    
                            <div className="flex-1 flex flex-col justify-center items-center flex-wrap my-[2rem]">
                                <img
                                src="/nrp-icons/banner-diagram.png"
                                alt=""
                                className=" h-25 lg:w-[35rem] w-[25rem]"
                                />
                            </div>
                        </div>
                    </div>
                </div>


                {/* Why TCS */}
                <div className="outer-wrapper w-[100%]">
                    <div className="inner-wrapper max-w-[70rem] mx-auto items-center px-6 pb-[.5rem]">
                        <div className=" flex flex-col justify-center items-center h-[150px]">
                        <h1 className="sm:text-[40px] text-[30px] font-bold">Why TCS</h1>
                        <hr className="react-reveal hr"/>
                        </div>
                        <div className="lg:flex grid flex-1 justify-center items-center   gap-[2rem] pr-[1rem] flex-wrap">
                            <div className="flex flex-1 flex-col justify-center items-center">
                                <img
                                src="/nrp-icons/user-trusted.svg"
                                alt=""
                                className="react-reveal h-20"
                                />
                                <h1 className="font-bold text-[17px] lg:text-[20px] pt-[1rem] text-[#373737]">
                                User Trusted
                                </h1>
                                <p
                                className="react-reveal text-sm text-center max-w-[25rem] mb-[1.5rem] px-[2.5rem]"
                                >
                                Reliability with ease and comfort
                                </p>
                            </div>
                            <div className="flex-1 flex flex-col justify-center items-center">
                                <img
                                src="/nrp-icons/fast-service.svg"
                                alt=""
                                className="react-reveal h-20"
                                />
                                <h1 className="font-bold text-[17px] lg:text-[20px] pt-[1rem] text-[#373737]">
                                Fast Services
                                </h1>
                                <p className="react-reveal text-sm text-center max-w-[25rem] mb-[1.5rem] px-[2.5rem]">Swift processing of documents</p>
                            </div>
                            <div className="flex-1 flex flex-col justify-center items-center ">
                                <img
                                src="/nrp-icons/attestations.svg"
                                alt=""
                                className="react-reveal h-20"
                                />
                                <h1 className="font-bold text-[17px] lg:text-[20px] pt-[1rem] text-[#373737]">
                                Attestations
                                </h1>
                                <p className="react-reveal text-sm text-center max-w-[25rem] mb-[1.5rem] px-[2rem]">Authentic attestations from various educational bodies</p>
                            </div>
                            <div className="flex-1 flex flex-col justify-center items-center">
                                <img
                                src="/nrp-icons/secure-&-trustworthy.svg"
                                alt=""
                                className="react-reveal h-20"
                                />
                                <h1 className="font-bold text-[17px] lg:text-[20px] pt-[1rem] text-[#373737]">
                                Secure and trustworthy
                                </h1>
                                <p className="react-reveal text-sm text-center max-w-[25rem] mb-[1.5rem] px-[2.5rem]">Dependable service with durability</p>
                            </div>
                        </div> 
                    </div>
                </div>
                
                {/* Our Process */}
                <div className=" outer-wrapper w-[100%] flex flex-col justify-center items-center  bg-[#f6f9fc]">
                    <div className="inner-wrapper max-w-[70rem] mx-auto items-center px-6 pt-[1.5rem]">
                        <div className=" flex flex-col justify-center items-center h-[150px]">
                            <h1 className="sm:text-[35px] text-[30px] font-bold">Our Process</h1>
                            <hr className="react-reveal hr"/>
                            <p className="react-reveal text-sm text-center max-w-[25rem] mb-[1.5rem] mt-[.5rem]">Get your document attestaion in 3 simple steps.</p>
                        </div>
                        <div className=" flex flex-col justify-center items-center ">
                       
                            <div className="flex-1 flex flex-col justify-center items-center my-[5rem] mx-[6rem]">
                                <img
                                src="/nrp-icons/our-process.svg"
                                alt=""
                                className="react-reveal h-25 w-[50rem] "
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
         </>
    );
};

export default AttestationMainScreen;